import { useEffect } from "react";
import styles from "./pageNotFound.module.css";

// Shown for unknown paths, and (with unknownDomain) on any host that isn't the main platform
// domain and isn't registered to a company (the DNS is a wildcard, so random subdomains still reach the app)
const PageNotFound = ({ unknownDomain = false }) => {
  const mainSiteUrl = `${window.location.protocol}//${process.env.REACT_APP_BASE_DOMAIN}`;

  useEffect(() => {
    document.title = "Page not found";
  }, []);

  return (<div className={`${styles.mainDiv}`}>
    <div className={`${styles.Card}`}>
      <p className={`${styles.Code}`}>404</p>
      <h1 className={`${styles.Heading}`}>Page not found</h1>
      {unknownDomain ? (<>
        <p className={`${styles.Desc}`}>
          The website <strong>{window.location.hostname}</strong> is not registered with Ezy Freight Logistics.
          Please check the address and try again.
        </p>
        <a href={mainSiteUrl} className={`${styles.HomeBU}`}>Go to Ezy Freight Logistics</a>
      </>) : (<>
        <p className={`${styles.Desc}`}>
          The page you are looking for doesn't exist or has been moved.
        </p>
        <a href="/" className={`${styles.HomeBU}`}>Back to home</a>
      </>)}
    </div>
  </div>);
};

export default PageNotFound;
